import { render, staticRenderFns } from "./VerticalNavigation.vue?vue&type=template&id=3e45c8ac&"
import script from "./VerticalNavigation.vue?vue&type=script&lang=js&"
export * from "./VerticalNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports